"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var NewCommentIcon_1 = __importDefault(require("../../../Icons/Notifications/NewCommentIcon"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Engage in a productive conversation by replying to",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "this comment"),
            ".")); },
        title: 'New comment posted on proposal'
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Participe en una conversaci\u00F3n productiva respondiendo a",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "este comentario"),
            ".")); },
        title: 'Nuevo comentario en tu propuesta'
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "\u56DE\u590D\u6B64\u8BC4\u8BBA"),
            "\uFF0C\u53C2\u4E0E\u5BCC\u6709\u6210\u6548\u7684\u5BF9\u8BDD")); },
        title: '就提案发表的新评论'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var GovernanceNewCommentOnProposalNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(NewCommentIcon_1.default, { height: "48", width: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" },
            i18N[locale].title,
            ' ',
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, notification.metadata.proposalTitle)),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.link))));
};
exports.default = GovernanceNewCommentOnProposalNotification;
